import { Flex, FlexProps } from "@chakra-ui/react";
import { ReactNode } from "react";

import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import { OnlyProductionEnvironment } from "@/environment/components/EnvironmentCallouts";
import SlackIntegrationForm from "@/integration/components/slack/SlackIntegrationForm";

type SlackConnectionGuardProps = FlexProps & {
  productionOnly?: boolean;
  children?: ReactNode;
};

export default function SlackConnectionGuard({
  productionOnly = false,
  children,
  ...rest
}: SlackConnectionGuardProps) {
  const { env, org } = useEnvironment();

  if (productionOnly && !env.isProduction) {
    return <OnlyProductionEnvironment entity="slack configuration" />;
  }

  return (
    <Flex direction="column" gap={8} {...rest}>
      {!org.integrations.slack && <SlackIntegrationForm isGuard />}
      {children}
    </Flex>
  );
}
